import { render, staticRenderFns } from "./modelLiquidation.vue?vue&type=template&id=f4f8ea9a"
import script from "./modelLiquidation.vue?vue&type=script&lang=js"
export * from "./modelLiquidation.vue?vue&type=script&lang=js"
import style0 from "./modelLiquidation.vue?vue&type=style&index=0&id=f4f8ea9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports